import { method } from '../support';
var memoize = function (controller, name, value) {
    console.log("memoizing " + name + " with " + value);
    Object.defineProperty(controller, name, { value: value });
    return value;
};
export var useMemo = function (controller) {
    var _a;
    (_a = controller.constructor.memoizedGetters) === null || _a === void 0 ? void 0 : _a.forEach(function (getter) {
        if (typeof controller[getter] === "function") {
            console.log("FUNCTION", method(controller, getter).call(controller));
            memoize(controller, getter, method(controller, getter).call(controller));
        }
        else {
            memoize(controller, getter, Reflect.get(controller, getter));
        }
    });
};
//# sourceMappingURL=use-memo.js.map